export default __webpack_public_path__ + "static/media/problema-09.c579b4d3.webp";